<template>
<div class="chapter">
<div class="inner_page">
<div id="fm01">
<br/><br/><br/><br/><br/>
<p class="Epigraph"><span class="Italics _idGenCharOverride-1">In childhood, we gradually walk away from innocence and then spend the rest of our lives wanting to get back there.</span></p>
<p class="Epigraph">—Skipper Sanders in the summer of 2005</p>
<br/><br/>
<p class="Epigraph"><span class="Italics _idGenCharOverride-1">Some are just visiting.</span></p>
<p class="Epigraph">—Joey Sanders in the fall of 2005</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-fm01.vue?be43bafe